import type { IObjectiveRequirementsAndObjectivesPurposeDetails } from './ObjectiveRequirementsAndObjectivesPurposeDetails.interface';

export default class ObjectiveRequirementsAndObjectivesPurposeDetails
  implements IObjectiveRequirementsAndObjectivesPurposeDetails {
  purchaseProperty: boolean;
  purchasePropertyAmount: number;
  construction: boolean;
  constructionAmount: number;
  renovations: boolean;
  renovationsAmount: number;
  investmentPurposes: boolean;
  investmentPurposesAmount: number;
  purchaseAsset: boolean;
  purchaseAssetAmount: number;
  refinance: boolean;
  refinanceAmount: number;
  debtConsolidation: boolean;
  debtConsolidationAmount: number;
  other: boolean;
  otherComments: string;
  otherAmount: number;
  totalAmount: number;

  static build = (data: IObjectiveRequirementsAndObjectivesPurposeDetails) =>
    new ObjectiveRequirementsAndObjectivesPurposeDetails(data);

  static blank = () => new ObjectiveRequirementsAndObjectivesPurposeDetails();

  /**
   * Constructor
   * @param {IObjectiveRequirementsAndObjectivesPurposeDetails} data
   */
  constructor(data?: IObjectiveRequirementsAndObjectivesPurposeDetails) {
    this.purchaseProperty = data?.purchaseProperty === true;
    this.purchasePropertyAmount = parseFloat(data?.purchasePropertyAmount || 0);
    this.construction = data?.construction === true;
    this.constructionAmount = parseFloat(data?.constructionAmount || 0);
    this.renovations = data?.renovations === true;
    this.renovationsAmount = parseFloat(data?.renovationsAmount || 0);
    this.investmentPurposes = data?.investmentPurposes === true;
    this.investmentPurposesAmount = parseFloat(data?.investmentPurposesAmount || 0);
    this.purchaseAsset = data?.purchaseAsset === true;
    this.purchaseAssetAmount = parseFloat(data?.purchaseAssetAmount || 0);
    this.refinance = data?.refinance === true;
    this.refinanceAmount = parseFloat(data?.refinanceAmount || 0);
    this.debtConsolidation = data?.debtConsolidation === true;
    this.debtConsolidationAmount = parseFloat(data?.debtConsolidationAmount || 0);
    this.other = data?.other === true;
    this.otherComments = data?.otherComments || '';
    this.otherAmount = parseFloat(data?.otherAmount || 0);
    this.totalAmount = parseFloat(data?.totalAmount || 0);
  }
}
